import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { ReactComponent as Svg } from '../svg/icon-grid.svg';

export default function GridIcon() {
  return (
    <SvgIcon>
      <Svg />
    </SvgIcon>
  );
}
